const initialState = {
  data: [],
  isLoading: false,
  error: false,
};

export const AdminSharedWithFiltersReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_ADMIN_SHARED_WITH_FILTERS':
      return {
        ...state,
        data: action.payload?.data || [],
        error: false,
      };

    case 'RESET_ADMIN_SHARED_WITH_FILTERS':
      return {
        ...state,
        data: [],
        isLoading: false,
        error: false,
      };

    case 'GET_ADMIN_SHARED_WITH_FILTERS_ERROR':
      return {
        ...state,
        data: [],
        error: true,
      };

    case 'API_START':
      if (action.payload === 'FETCH_ADMIN_SHARED_WITH_FILTERS') {
        return { ...state, isLoading: true, error: false };
      }
      return state;

    case 'API_END':
      if (action.payload === 'FETCH_ADMIN_SHARED_WITH_FILTERS') {
        return { ...state, isLoading: false };
      }
      return state;

    case 'API_ERROR':
      if (action.payload === 'FETCH_ADMIN_SHARED_WITH_FILTERS') {
        return { ...state, isLoading: false, error: true };
      }
      return state;

    default:
      return state;
  }
};
